(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cts-feature-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cts-feature-collection')) {
    customElements.define('cts-feature-collection', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._onChange = (event) => {
          if (event.target.matches('[data-cts-variant-select]')) this.updateVariantPrice(event.target);
        };
        this._onSubmit = (event) => {
          const form = event.target.closest('form[data-cts-add-form]');
          if (form && this.contains(form)) this.addToCart(event, form);
        };
        this.addEventListener('change', this._onChange);
        this.addEventListener('submit', this._onSubmit);
      }

      disconnectedCallback() {
        if (!this._connected) return;
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('submit', this._onSubmit);
        this._connected = false;
      }

      updateVariantPrice(select) {
        const option = select.selectedOptions && select.selectedOptions[0];
        const card = select.closest('[data-cts-card]');
        if (!option || !card) return;
        const currentPrice = card.querySelector('[data-cts-current-price]');
        const comparePrice = card.querySelector('[data-cts-compare-price]');
        if (currentPrice) currentPrice.textContent = option.dataset.price || '';
        if (comparePrice) {
          const currentValue = Number(option.dataset.priceValue || 0);
          const compareValue = Number(option.dataset.compareValue || 0);
          if (compareValue > currentValue && option.dataset.comparePrice) {
            comparePrice.textContent = option.dataset.comparePrice;
            comparePrice.hidden = false;
          } else {
            comparePrice.textContent = '';
            comparePrice.hidden = true;
          }
        }
      }

      async addToCart(event, form) {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const card = form.closest('[data-cts-card]');
        const status = card ? card.querySelector('[data-cts-status]') : null;
        if (!button || button.disabled || button.classList.contains('is-loading')) return;
        const errorLabel = this.dataset.errorLabel;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        try {
          const formData = new FormData(form);
          const possibleCartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const cartUI = possibleCartUI && typeof possibleCartUI.getSectionsToRender === 'function' && typeof possibleCartUI.renderContents === 'function' ? possibleCartUI : null;
          if (cartUI) {
            formData.append('sections', cartUI.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          } else {
            formData.append('sections', 'cart-icon-bubble');
            formData.append('sections_url', window.location.pathname);
          }

          const response = await fetch(form.action, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json'
            },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || errorLabel);

          if (cartUI) {
            cartUI.renderContents(result);
          } else if (result.sections && result.sections['cart-icon-bubble']) {
            this.updateCartIconBubble(result.sections['cart-icon-bubble']);
          }

          if (status) status.textContent = this.dataset.addedLabel;
        } catch (error) {
          if (status) {
            status.textContent = error.message || errorLabel;
            status.classList.add('is-error');
          }
        } finally {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          button.disabled = form.dataset.available !== 'true';
        }
      }

      updateCartIconBubble(sectionHtml) {
        const parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const updatedBubble = parsedDocument.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (updatedBubble && currentBubble) currentBubble.innerHTML = updatedBubble.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cts-jewelry-value-panel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cts-jewelry-reviews')) {
    customElements.define('cts-jewelry-reviews', class extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-topic-filter]'));
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
        this.track = this.querySelector('[data-review-track]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.onClickBound = this.onClick.bind(this);
        this.onScrollBound = this.updateArrows.bind(this);
        this.addEventListener('click', this.onClickBound);
        if (this.track) this.track.addEventListener('scroll', this.onScrollBound, { passive: true });
        this.updateArrows();
      }

      disconnectedCallback() {
        if (this.onClickBound) this.removeEventListener('click', this.onClickBound);
        if (this.track && this.onScrollBound) this.track.removeEventListener('scroll', this.onScrollBound);
      }

      onClick(event) {
        const topicButton = event.target.closest('[data-topic-filter]');
        if (topicButton && this.contains(topicButton)) {
          event.preventDefault();
          this.buttons.forEach((button) => {
            const active = button === topicButton;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          return;
        }
        const prev = event.target.closest('[data-carousel-prev]');
        const next = event.target.closest('[data-carousel-next]');
        if (prev && this.contains(prev)) this.moveCarousel(-1);
        if (next && this.contains(next)) this.moveCarousel(1);
      }

      moveCarousel(direction) {
        if (!this.track) return;
        const firstVisibleCard = this.cards.find((card) => !card.hidden);
        const cardWidth = firstVisibleCard ? firstVisibleCard.getBoundingClientRect().width : this.track.clientWidth;
        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        const visibleCards = window.innerWidth < 750 ? 1 : (window.innerWidth < 990 ? 2 : 3);
        const distance = (cardWidth + gap) * visibleCards;
        this.track.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.track) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 3;
        if (this.nextButton) this.nextButton.disabled = maxScroll <= 3 || this.track.scrollLeft >= maxScroll - 3;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  









  } catch(e) { console.error(e); }
})();
})();
